import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { ArtworkOnVectorEquipmentPage, ArtworkOnVectorEquipmentPageProps } from "./ArtworkOnVectorEquipmentPage";

export const EMPTY_PAGE_CONTENT: ArtworkOnVectorEquipmentPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/help-safety/near-our-network/artwork-on-our-equipment";

export const ArtworkOnVectorEquipmentPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<ArtworkOnVectorEquipmentPageProps>("artwork_on_vector_equipment", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <ArtworkOnVectorEquipmentPage {...routeProps} {...content} />;
};
